import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatChip, MatChipRemove, MatChipSet } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { Filter, FilterOperator, FilterType } from '../models/filters.model';
import { OPERATORS_TRANSLATIONS } from '../utils/filters.utils';

@Component({
  selector: 'rms-filters-chips',
  imports: [MatChip, MatChipRemove, MatChipSet, TranslateModule, MatIcon],
  template: `
    <mat-chip-set>
      @for (filter of filters; track filter.id) {
        @if (filter.id) {
          <mat-chip
            [removable]="true"
            (removed)="removeFilter.emit(filter.id)">
            <span>{{ filter.label ?? '' | translate }} {{ operatorsTranslations[filter.operator] | translate }}: </span>
            <span class="font-bold">{{ getValue(filter) | translate }}</span>
            <button matChipRemove>
              <mat-icon
                class="icon-xs"
                svgIcon="remix:System/close-large-fill" />
            </button>
          </mat-chip>
        }
      }
    </mat-chip-set>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersChipsComponent {
  @Input() public filters: Filter[] = [];

  @Output() public removeFilter = new EventEmitter<string>();

  protected operatorsTranslations = OPERATORS_TRANSLATIONS;

  protected getValue(filter: Filter): string {
    if (filter.type === FilterType.SELECT) {
      return filter.optionLabel ?? filter.value;
    }

    if (filter.type !== FilterType.DATE) {
      return filter.value.toString();
    }

    if (filter.operator === FilterOperator.BETWEEN && filter.valueFrom && filter.valueTo) {
      return `${filter.valueFrom.toFormat('dd/MM/yyyy HH:mm')} - ${filter.valueTo.toFormat('dd/MM/yyyy HH:mm')}`;
    }

    if (filter.operator === FilterOperator.AFTER && filter.valueFrom) {
      return filter.valueFrom.toFormat('dd/MM/yyyy HH:mm');
    }

    if (filter.operator === FilterOperator.BEFORE && filter.valueTo) {
      return filter.valueTo.toFormat('dd/MM/yyyy HH:mm');
    }

    return '';
  }
}
